import { PartnerType } from '@enums';
import fonbet from '@images/partners/fonbet.png';
import gislaved from '@images/partners/gislaved.png';
import haier from '@images/partners/haier.png';
import kinopoisk from '@images/partners/kinopoisk.png';
import lada from '@images/partners/lada.png';
import mir from '@images/partners/mir.png';
import olymp from '@images/partners/olimpbet.svg';
import rostel from '@images/partners/rostelecom.png';
import s7 from '@images/partners/s7.png';
import sogaz from '@images/partners/sogaz.png';
import tbank from '@images/partners/tbank.png';
var KHLPartners = [{
  id: '1',
  name: 'Фонбет',
  logo: fonbet,
  title: PartnerType.TitlePartner,
  href: 'https://fon.bet/authProcess/registration?promoAlias=khl_new&affijet-click=u2d14c021b1754dde82ce01fefaec4d2d&partner_id=16996&utm_medium=sponsorship&sub_1=%7Bkhl%7D&sub_2=%7Blogo_footer%7D'
}, {
  id: '2',
  name: 'Согаз',
  logo: sogaz,
  title: PartnerType.GeneralPartner,
  href: 'https://www.sogaz.ru/?utm_source=khl&utm_medium=static&utm_campaign=sogaz_main_khl_logo_2024'
}, {
  id: '3',
  name: 'Т-Банк',
  logo: tbank,
  title: PartnerType.GeneralPartner,
  href: 'https://www.tbank.ru/'
}, {
  id: '4',
  name: 'МИР',
  logo: mir,
  title: PartnerType.OfficialPartner,
  href: 'https://vamprivet.ru/?utm_source=khl&utm_medium=sp&utm_campaign=NSPK_SBP_KHL_2024-2025&utm_term=bottom_logo&utm_content=none'
}, {
  id: '5',
  name: 'Ростелеком',
  logo: rostel,
  title: PartnerType.Partner,
  href: 'http://www.rt.ru'
}, {
  id: '6',
  name: 'LADA',
  logo: lada,
  title: PartnerType.Partner,
  href: 'https://www.lada.ru/'
}, {
  id: '7',
  name: 'Кинопоиск',
  logo: kinopoisk,
  title: PartnerType.Partner,
  href: 'https://hd.kinopoisk.ru/sport/competition/34149/?utm_source=kinopoisk&utm_medium=paid_media&utm_campaign=promocode&utm_content=button&utm_term=khl267online'
}, {
  id: '8',
  name: 'Gislaved',
  logo: gislaved,
  title: PartnerType.Partner,
  href: 'https://gislaved-tire.ru/?utm_source=khlsite&utm_medium=logo'
}, {
  id: '9',
  name: 'Haier',
  logo: haier,
  title: PartnerType.Partner,
  href: 'https://haieronline.ru/'
}, {
  id: '10',
  name: 'S7',
  logo: s7,
  title: PartnerType.Partner,
  href: 'https://www.s7.ru/ru/?utm_source=khl&utm_medium=web&utm_campaign=partners'
}];
var amurPartners = [{
  id: '14',
  logo: olymp,
  title: PartnerType.OfficialPartner,
  href: '#'
}];
export { amurPartners, KHLPartners };